// Firebase service for React
import { initializeApp } from 'firebase/app';
import { 
  getAuth, 
  GoogleAuthProvider, 
  TwitterAuthProvider, 
  GithubAuthProvider,
  signInWithPopup,
  signOut,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
  onAuthStateChanged,
  User,
  signInWithCustomToken
} from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { ethers } from 'ethers';

// Your web app's Firebase configuration
// Replace with the actual config from app/scripts/firebaseConfig.js
const firebaseConfig = {
  apiKey: "AIzaSyCwKL33-vzoLVcOk23fdeyxYvLzuPnbr0E",
  authDomain: "phantomclash-ccddd.firebaseapp.com",
  projectId: "phantomclash-ccddd",
  storageBucket: "phantomclash-ccddd.appspot.com",
  messagingSenderId: "321881459446",
  appId: "1:321881459446:web:fa81cc734047d39074bad7",
  measurementId: "G-KKV48527Z0"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

// Initialize providers
const googleProvider = new GoogleAuthProvider();
const twitterProvider = new TwitterAuthProvider();
const githubProvider = new GithubAuthProvider();

// Social login functions
export const signInWithGoogle = async () => {
  try {
    const result = await signInWithPopup(auth, googleProvider);
    return result.user;
  } catch (error) {
    console.error('Google Sign-In Error:', error);
    throw error;
  }
};

export const signInWithTwitter = async () => {
  try {
    const result = await signInWithPopup(auth, twitterProvider);
    return result.user;
  } catch (error) {
    console.error('Twitter Sign-In Error:', error);
    throw error;
  }
};

export const signInWithGithub = async () => {
  try {
    const result = await signInWithPopup(auth, githubProvider);
    return result.user;
  } catch (error) {
    console.error('Github Sign-In Error:', error);
    throw error;
  }
};

// Metamask login function
export const signInWithMetamask = async () => {
  if (typeof window.ethereum === 'undefined') {
    throw new Error('Please install Metamask to use this feature.');
  }

  try {
    // Request account access
    await window.ethereum.request({ method: 'eth_requestAccounts' });

    // Get provider and signer
    const provider = new ethers.BrowserProvider(window.ethereum);
    const signer = await provider.getSigner();
    const address = await signer.getAddress();

    // Sign message
    const message = 'Sign in with Metamask to Phantom Clash.';
    const signature = await signer.signMessage(message);
    
    // Authenticate with backend
    const response = await fetch('https://phantomclash-auth-web3-27406592615.us-central1.run.app/authenticate', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ address, signature }),
    });

    const data = await response.json();

    if (!data.token) {
      throw new Error(data.error || 'Authentication failed');
    }

    // Sign in with custom token
    const userCredential = await signInWithCustomToken(auth, data.token);
    return userCredential.user;
  } catch (error) {
    console.error('Metamask Sign-In Error:', error);
    throw error;
  }
};

export const logOut = async () => {
  await signOut(auth);
};

export {
  auth,
  getAuth,
  onAuthStateChanged,
  signInWithPopup,
  GoogleAuthProvider,
  TwitterAuthProvider,
  GithubAuthProvider,
  signOut,
  signInWithCustomToken,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
  googleProvider,
  twitterProvider,
  githubProvider,
};
export default app; 